import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (email: string) => {
      try {
        const result = await apiClient.user.deleteUser.mutation({ params: { email } });
        if (result.status !== 204) throw result.body;
        return result.body;
      } catch (error) {
        showErrorToast(error, 'Failed to delete user');
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users-list'] });
      toast.success('User deleted successfully');
    },
  });
};
